export const START_UPLOAD_CSV_TO_STATIONS = 'custom/station/START_UPLOAD_CSV_TO_STATIONS';
export const UPLOAD_CSV_TO_STATIONS = 'custom/station/UPLOAD_CSV_TO_STATIONS';
export const SUCCESS_UPLOAD_CSV_TO_STATIONS = 'custom/station/SUCCESS_UPLOAD_CSV_TO_STATIONS';
export const FAIL_UPLOAD_CSV_TO_STATIONS = 'custom/station/FAIL_UPLOAD_CSV_TO_STATIONS';
export const UPLOAD_STATION_DEVICES = 'custom/station/UPLOAD_STATION_DEVICES';
